import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiheaderService } from '../common/services/apiheader.service';
import { URLPaths } from '../common/utilities/urlPaths.config';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDetailsService {
  constructor(private http: HttpClient) {}

  getInvoiceNumbers(client: string, project: string): Observable<any> {
    let params = new HttpParams()
      .append('client', client)
      .append('project', project);

    return this.http.get(URLPaths.URL_INVOICE_NUMBERS, {
      headers: ApiheaderService.getHeaders(),
      params: params
    });
  }

  getInvoiceDetails(invoiceNumber: string, client: string, project: string): Observable<any> {
    let params = new HttpParams()
      .append('invoice_number', invoiceNumber)
      .append('client', client)
      .append('project', project);

    return this.http.get(URLPaths.URL_INVOICE_DETAILS, {
      headers: ApiheaderService.getHeaders(),
      params: params
    });
  }

  updateInvoiceDetails(data: any): Observable<any> {
    return this.http.put(URLPaths.URL_INVOICE_DETAILS, {
      update_invoice_details: data
    }, {
      headers: ApiheaderService.getHeaders()
    });
  }
getBankDetails(bankId: number): Observable<any> {
  let params = new HttpParams()
    .append('BankId', bankId.toString());

  return this.http.get(URLPaths.URL_BANK_DETAILS, {
    headers: ApiheaderService.getHeaders(),
    params: params
  });
}
}
